<script setup lang="ts">
import type { CardSize } from "./ContentGridDynamicTypes";
defineProps<{ size: CardSize }>();
</script>

<template>
	<div
		class="article-container"
		:class="size"
	>
		<div class="article">
			<div class="image-wrapper">
				<TnSkeleton
					width="100%"
					height="100%"
				/>
			</div>
			<div class="content">
				<TnSkeleton
					width="90%"
					height="100%"
					class="title"
				/>
				<TnSkeleton
					width="50%"
					height="100%"
					class="title"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.article-container {
	--image-aspect-ratio: 3/2;
	--column-span: span 12;

	grid-column: var(--column-span);
	text-decoration: none;

	.article {
		display: flex;
		flex-direction: column;
		gap: $spacing-m;

		.content {
			display: flex;
			flex-direction: column;
			gap: $spacing-xs;
			width: 100%;
		}
	}

	.image-wrapper {
		aspect-ratio: var(--image-aspect-ratio);
		width: 100%;
		height: 100%;
		max-width: 100%;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&.xl {
		--column-span: span 12;
		--image-aspect-ratio: 3/2;

		.article {
			flex-flow: row nowrap;
			gap: $spacing-l;
		}

		.content {
			justify-content: center;
		}

		.title {
			height: 56px !important;
		}

		@include breakpoint(mobile) {
			.article {
				flex-direction: column;
			}

			.title {
				height: 36px !important;
			}
		}
	}

	&.lg {
		--column-span: span 6;
		--image-aspect-ratio: 16/9;

		.title {
			height: 36px !important;
		}

		@include breakpoint(mobile) {
			.title {
				height: 26px !important;
			}
		}
	}

	&.md {
		--column-span: span 4;
		--image-aspect-ratio: 16/9;

		.title {
			height: 30px !important;
		}
	}

	&.sm {
		--column-span: span 3;
		--image-aspect-ratio: 3/2;

		.title {
			height: 24px !important;
		}
	}

	&.lg,
	&.md,
	&.sm {
		@include breakpoint(mobile) {
			--image-aspect-ratio: 1/1;
		}
	}

	&.md,
	&.sm {
		@include breakpoint(mobile) {
			--column-span: span 12;

			.article {
				background: $color-neutrals-25-tint;
				flex-flow: row nowrap;
				gap: $spacing-l;
			}

			.content {
				padding: $spacing-s $spacing-m $spacing-m 0;
			}

			.title {
				height: 22px !important;
			}

			.image-wrapper {
				width: 114px;
				min-width: 114px;
			}
		}
	}
}
</style>
